export const ONBOARDING_V2_STREAM_TIMING = {
  initialTypingMs: 360,
  paragraphPauseMs: 140,
  settleMs: 100,
  wordIntervalMs: 38,
  wordRevealMs: 180,
  wordStreamLeadInMs: 80,
} as const;

export type T_OnboardingV2StreamToken = {
  delayMs: number;
  isWord: boolean;
  text: string;
};

function getWordCount(text: string): number {
  return text.match(/\S+/gu)?.length ?? 0;
}

export function getOnboardingV2StreamPartStartDelay(
  previousParts: readonly string[],
): number {
  const previousWordCount = previousParts.reduce(
    (total, part) => total + getWordCount(part),
    0,
  );
  return (
    ONBOARDING_V2_STREAM_TIMING.wordStreamLeadInMs +
    previousWordCount * ONBOARDING_V2_STREAM_TIMING.wordIntervalMs +
    previousParts.length * ONBOARDING_V2_STREAM_TIMING.paragraphPauseMs
  );
}

export function getOnboardingV2MessageStreamDuration(
  parts: readonly string[],
): number {
  if (parts.length === 0) return 0;
  const finalPart = parts.at(-1);
  if (finalPart === undefined) return 0;
  const finalWordCount = getWordCount(finalPart);
  const finalPartStart = getOnboardingV2StreamPartStartDelay(
    parts.slice(0, -1),
  );
  return (
    finalPartStart +
    Math.max(0, finalWordCount - 1) *
      ONBOARDING_V2_STREAM_TIMING.wordIntervalMs +
    ONBOARDING_V2_STREAM_TIMING.wordRevealMs +
    ONBOARDING_V2_STREAM_TIMING.settleMs
  );
}

export function getOnboardingV2StreamTokens(
  text: string,
  startDelayMs: number = ONBOARDING_V2_STREAM_TIMING.wordStreamLeadInMs,
): T_OnboardingV2StreamToken[] {
  let wordIndex = 0;
  return text
    .split(/(\s+)/u)
    .filter((token) => token.length > 0)
    .map((token) => {
      const isWord = /\S/u.test(token);
      const delayMs = isWord
        ? startDelayMs + wordIndex * ONBOARDING_V2_STREAM_TIMING.wordIntervalMs
        : 0;
      if (isWord) wordIndex += 1;
      return { delayMs, isWord, text: token };
    });
}
